const W = 0.52;
const M = 0.06;

export const mainKeys = {
  "#00070029": { text: "Esc", style: { marginRight: M * 2 + W + "rem" } },
  "#0007003A": { text: "F1" },
  "#0007003B": { text: "F2" },
  "#0007003C": { text: "F3" },
  "#0007003D": {
    text: "F4",
    style: { marginRight: M + (M + W) * 0.5 + "rem" },
  },
  "#0007003E": { text: "F5" },
  "#0007003F": { text: "F6" },
  "#00070040": { text: "F7" },
  "#00070041": {
    text: "F8",
    style: { marginRight: M + (M + W) * 0.5 + "rem" },
  },
  "#00070042": { text: "F9" },
  "#00070043": { text: "F10" },
  "#00070044": { text: "F11" },
  "#00070045": { text: "F12" },
  "#00070035": { text: "~<br/>`" },
  "#0007001E": { text: "!<br/>1" },
  "#0007001F": { text: "@<br/>2" },
  "#00070020": { text: "#<br/>3" },
  "#00070021": { text: "$<br/>4" },
  "#00070022": { text: "%<br/>5" },
  "#00070023": { text: "^<br/>6" },
  "#00070024": { text: "&<br/>7" },
  "#00070025": { text: "*<br/>8" },
  "#00070026": { text: "(<br/>9" },
  "#00070027": { text: ")<br/>0" },
  "#0007002D": { text: "_<br/>-" },
  "#0007002E": { text: "+<br/>=" },
  "#0007002A": { text: "Backspace", style: { width: W * 2 + M + "rem" } },
  "#0007002B": { text: "Tab", style: { width: W + (W + M) * 0.5 + "rem" } },
  "#00070014": { text: "Q" },
  "#0007001A": { text: "W" },
  "#00070008": { text: "E" },
  "#00070015": { text: "R" },
  "#00070017": { text: "T" },
  "#0007001C": { text: "Y" },
  "#00070018": { text: "U" },
  "#0007000C": { text: "I" },
  "#00070012": { text: "O" },
  "#00070013": { text: "P" },
  "#0007002F": { text: "{<br/>[" },
  "#00070030": { text: "}<br/>]" },
  "#00070031": {
    text: "|<br/>\\",
    style: { width: W + (W + M) * 0.5 + "rem" },
  },
  "#00070039": { text: "CapsLock", style: { width: W + W * 0.75 + M + "rem" } },
  "#00070004": { text: "A" },
  "#00070016": { text: "S" },
  "#00070007": { text: "D" },
  "#00070009": { text: "F" },
  "#0007000A": { text: "G" },
  "#0007000B": { text: "H" },
  "#0007000D": { text: "J" },
  "#0007000E": { text: "K" },
  "#0007000F": { text: "L" },
  "#00070033": { text: ":<br/>;" },
  "#00070034": { text: "\"<br/>'" },
  "#00070028": { text: "Enter", style: { width: W + W * 1.25 + M + "rem" } },
  "#000700E1": {
    text: "LShift",
    style: { width: W + W * 1.25 + M * 1.5 + "rem" },
  },
  "#0007001D": { text: "Z" },
  "#0007001B": { text: "X" },
  "#00070006": { text: "C" },
  "#00070019": { text: "V" },
  "#00070005": { text: "B" },
  "#00070011": { text: "N" },
  "#00070010": { text: "M" },
  "#00070036": { text: "<<br/>," },
  "#00070037": { text: "><br/>." },
  "#00070038": { text: "?<br/>/" },
  "#000700E5": {
    text: "RShift",
    style: { width: W + W * 1.75 + M * 1.5 + "rem" },
  },
  "#000700E0": { text: "LCtrl ", style: { width: W * 1.3 + "rem" } },
  "#000700E3": { text: "LWin/Cmd", style: { width: W * 1.3 + "rem" } },
  "#000700E2": { text: "LAlt/Opt", style: { width: W * 1.3 + "rem" } },
  "#0007002C": { text: "Space", style: { width: W * 6.7 + "rem" } },
  "#000700E6": { text: "RAlt/Opt", style: { width: W * 1.3 + "rem" } },
  "#000700E7": { text: "RWin/Cmd", style: { width: W * 1.3 + "rem" } },
  "#00070076": { text: "Menu", style: { width: W * 1.3 + "rem" } },
  "#000700E4": { text: "RCtrl", style: { width: W * 1.3 + "rem" } },
};

export const centerClusterKeys = {
  "#00070046": { text: "Print Screen" },
  "#00070047": { text: "Scroll Lock" },
  "#00070048": { text: "Pause" },
  "#00070049": { text: "Insert" },
  "#0007004A": { text: "Home" },
  "#0007004B": { text: "Page Up" },
  "#0007004C": { text: "Delete" },
  "#0007004D": { text: "End" },
  "#0007004E": { text: "Page Down" },
  "#00070052": {
    text: "↑",
    style: {
      marginTop: M + W + "rem",
      marginRight: M + W + "rem",
      marginLeft: M + W + "rem",
    },
  },
  "#00070050": { text: "←" },
  "#00070051": { text: "↓" },
  "#0007004F": { text: "→" },
};

export const numpadKeys = {
  "#00070053": {
    text: "Num Lock",
    style: { marginTop: M + W + "rem" },
  },
  "#00070054": { text: "/", style: { marginTop: M + W + "rem" } },
  "#00070055": { text: "*", style: { marginTop: M + W + "rem" } },
  "#00070056": { text: "-", style: { marginTop: M + W + "rem" } },
  "#0007005F": { text: "7" },
  "#00070060": { text: "8" },
  "#00070061": { text: "9" },
  "#00070057": { text: "+" },
  "#0007005C": { text: "4" },
  "#0007005D": { text: "5" },
  "#0007005E": { text: "6", style: { marginRight: M + W + "rem" } },
  "#00070059": { text: "1" },
  "#0007005A": { text: "2" },
  "#0007005B": { text: "3", style: { marginRight: M + W + "rem" } },
  "#00070062": { text: "0", style: { width: M + W * 2 + "rem" } },
  "#00070063": { text: "." },
  "#00070058": { text: "Enter" },
};

export const mediaKeys = {
  "#000C00E2": {
    text: "Mute",
  },
  "#000C00E9": {
    text: "Volume Up",
  },
  "#000C00EA": {
    text: "Volume Down",
  },
  "#000C00B6": {
    text: "Prev Track",
  },
  "#000C00B5": {
    text: "Next Track",
  },
  "#000C00CD": {
    text: "Play/ Pause",
  },
};

export const hatsuLeftKeys = {
  "#00920C0B": { text: "LFn" },
  // "#00920C0C": { text: "⬤" },
  "#00920C0D": { text: "LFnS" },
  "#00920C1A": { text: "LFn1" },
  "#00920C1B": { text: "LFn3" },
  "#00920C1C": { text: "LFn4" },
  "#00920C1D": { text: "LFn5" },
  "#00920C1E": { text: "LFn6" },
  "#00920C1F": { text: "LFn7" },
  "#00920C13": { text: "Layer1" },
  "#00920C14": { text: "Layer2" },
  "#00920C15": { text: "Layer3" },
  "#00920C16": { text: "Layer4" },
  "#00920C17": { text: "Layer5" },
  "#00920C18": { text: "Layer6" },
  "#00920C19": { text: "Layer7" },
};

export const hatsuRightKeys = {
  "#00920C0E": { text: "RFn" },
  // "#00920C0F": { text: "⬤" },
  "#00920C10": { text: "RFnS" },
  "#00920C20": { text: "RFn1" },
  "#00920C21": { text: "RFn3" },
  "#00920C22": { text: "RFn4" },
  "#00920C23": { text: "RFn5" },
  "#00920C24": { text: "RFn6" },
  "#00920C25": { text: "RFn7" },
  "#00920C13": { text: "Layer1" },
  "#00920C14": { text: "Layer2" },
  "#00920C15": { text: "Layer3" },
  "#00920C16": { text: "Layer4" },
  "#00920C17": { text: "Layer5" },
  "#00920C18": { text: "Layer6" },
  "#00920C19": { text: "Layer7" },
};
